import Skeleton from '@mui/material/Skeleton';
import Grid from '@mui/material/Grid';

const ResourcePageSkeleton = () => (
	<Grid
		container
		rowSpacing={2}
		mt={1}
		mb={5}
		role='progressbar'
		aria-label='Loading'
		data-testid='skeletonLoading'
	>
		<Grid item xs={12}>
			<Skeleton variant='rectangle' width='100%' height='24px' />
		</Grid>
		<Grid item xs={12}>
			<Skeleton variant='rectangle' width='100%' height='144px' />
		</Grid>
		<Grid item xs={12}>
			<Skeleton variant='rectangle' width='100%' height='48px' />
		</Grid>
		<Grid item xs={12}>
			<Skeleton variant='rectangle' width='100%' height='36px' />
		</Grid>
		<Grid item xs={12}>
			<Skeleton variant='rectangle' width='100%' height='72px' />
		</Grid>
		<Grid item xs={12}>
			<Skeleton variant='rectangle' width='100%' height='36px' />
		</Grid>
		<Grid item xs={12}>
			<Skeleton variant='rectangle' width='100%' height='72px' />
		</Grid>
		<Grid item xs={12}>
			<Skeleton variant='rectangle' width='100%' height='36px' />
		</Grid>
		<Grid item xs={12}>
			<Skeleton variant='rectangle' width='100%' height='72px' />
		</Grid>
	</Grid>
);

export default ResourcePageSkeleton;
